export enum UserReplacementFieldNames {
  ProjectNumber = "ProjectNumber",
  ProjectName = "ProjectName",
  ProjectType = "ProjectType",
  ProductCategory = "ProductCategory",
  ProjectStatus = "ProjectStatus",
  Milestone = "Milestone",
  MilestoneStatus = "MilestoneStatus",
  Role = "Role",
  RoleType = "RoleType",
  Secure = "Secure",
  NotApplicableEligible = "NotApplicableEligible",
}
